var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 1.33333C10.5267 1.33333 12.78 2.75333 13.88 5C12.78 7.24667 10.5267 8.66667 7.99999 8.66667C5.47332 8.66667 3.21999 7.24667 2.11999 5C3.21999 2.75333 5.47332 1.33333 7.99999 1.33333ZM7.99999 0C4.66666 0 1.81999 2.07333 0.666656 5C1.81999 7.92667 4.66666 10 7.99999 10C11.3333 10 14.18 7.92667 15.3333 5C14.18 2.07333 11.3333 0 7.99999 0ZM7.99999 3.33333C8.91999 3.33333 9.66666 4.08 9.66666 5C9.66666 5.92 8.91999 6.66667 7.99999 6.66667C7.07999 6.66667 6.33332 5.92 6.33332 5C6.33332 4.08 7.07999 3.33333 7.99999 3.33333ZM7.99999 2C6.34666 2 4.99999 3.34667 4.99999 5C4.99999 6.65333 6.34666 8 7.99999 8C9.65332 8 11 6.65333 11 5C11 3.34667 9.65332 2 7.99999 2Z",
    fill: "#C1C7CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.b375911caeb716969852c84dad8b76bd.svg";
export { ForwardRef as ReactComponent };